export default __webpack_public_path__ + "static/media/loai.fe3f4dd6.m4v";